<template>
  <div>
    <input v-if="dragged" type="hidden" id="image_order" name="image_order" :value="JSON.stringify(images)">
    <input v-if="delete_items" type="hidden" id="to_be_deleted_images" name="to_be_deleted_images"
      :value="JSON.stringify(to_be_deleted_images)">
    <draggable v-model="images" v-if="images.length > 0" v-bind="dragOptions" class="dragableimages" @end="createimages()"
      id="draggablecontainer">
      <transition-group type="transition" :name="!drag ? 'flip-list' : null">
        <div v-for="(item, index) in images" :key="index + 'images'" class="relative">
          <file_input_preview id='image' :nr="index" accept="image/png, image/jpeg, image/jpg, image/webp"
            :currentvalue="item.src ?? null"></file_input_preview>
          <div @click="removeItem(index, item)"
            class="w-5 h-5 absolute text-xs -right-2 -top-2 rounded-full bg-gray-100 text-gray-700 border border-gray-300 flex items-center justify-center hover:scale-90 transition cursor-pointer hover:bg-gray-300 z-5">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-3 w-3" fill=currentColor
              viewBox="0 0 384 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->
              <path
                d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
            </svg>
          </div>
        </div>
      </transition-group>
    </draggable>
    <div key="new" @click="addImage()"
      class="flex mt-10 flex-col items-center justify-center pt-5 pb-6 px-4  text-gray-500 border border-gray-500 rounded-lg hover:bg-gray-200 js_skeleton z-[1] w-full h-full transition cursor-pointer">
      <p class="text-5xl">+</p>
      <p class="mb-2 text-sm"><span class="font-semibold">Click to upload</span>
      </p>
    </div>
  </div>
</template>

<style>
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>

<script>
import draggable from "vuedraggable";
import $ from 'jquery'

export default {
  components: {
    draggable,
  },

  data() {
    return {
      images: [],
      to_be_deleted_images: [],
      currentUrl: "",
      drag: false,
      dragged: false,
      delete_items: false,
    };
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "draggableimageghost",
      };
    },
  },

  methods: {
    createimages() {
      this.dragged = true;
      var externalImages = [];
      var internalImages = [];
      for (var elem in this.images) {
        if ((this.images[elem].location = "hosted")) {
          var item = {
            url: this.images[elem].href,
            caption: this.images[elem].caption,
            map: this.images[elem].map,
          };
          internalImages.push(item);
        } else {
          var item = {
            url: this.images[elem].href,
            caption: this.images[elem].caption,
            map: this.images[elem].map,
          };
          externalImages.push(item);
        }
      }
      var finalImages = {
        external: externalImages,
        hosted: internalImages,
      };
      $("#images").val(JSON.stringify(finalImages));
    },
    addImage() {
      this.images.push({
        id: null,
        src: null,
        href: null,
        alt: null,
        map: null,
        location: "external",
      });
    },
    removeItem(index, item) {
      this.to_be_deleted_images.push(item);
      this.delete_items = true;
      this.images.splice(index, 1);
    },
    mipmap(src, res) {
      var imgblocks = src.split("/");
      var imgfile = imgblocks[imgblocks.length - 1];
      var thumbnailimgsmall =
        imgfile.split(".")[0] + "." + res + "." + imgfile.split(".")[1];
      imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
      return imgblocks.join("/");
    },
    async getData() {
      var content = JSON.parse($("#images_raw").val());
      var imageArray = [];
      var external = content.external;
      var hosted = content.hosted;

      for (var index in external) {
        if (external[index].url != "") {
          var object = {
            id: index,
            src: external[index].url,
            href: external[index].url,
            alt: external[index].caption,
            map: external[index].map,
            location: "external",
          };
          imageArray.push(object);
          this.images.push(object);
        }
      }

      for (var index in hosted) {
        if (hosted[index].url != "") {
          var imgblocks = hosted[index].url.split("/");
          var imgfile = imgblocks[imgblocks.length - 1];
          var thumbnailimgsmall =
            imgfile.split(".")[0] + ".250." + imgfile.split(".")[1];
          imgblocks[imgblocks.length - 1] = thumbnailimgsmall;
          var thumbnailurlsmall = imgblocks.join("/");

          var object = {
            id: external.length + index,
            src: thumbnailurlsmall,
            href: hosted[index].url,
            alt: hosted[index].caption,
            map: hosted[index].map,
            location: "hosted",
          };
          imageArray.push(object);
          this.images.push(object);
        }
      }

      this.images = this.images.sort(function (a, b) {
        if (JSON.parse(a.map[0]).position === JSON.parse(b.map[0]).position) {
          return 0;
        }
        else {
          return (JSON.parse(a.map[0]).position < JSON.parse(b.map[0]).position) ? -1 : 1;
        }
      })


    },
  },

  created() {
    this.getData();
    this.currentUrl = window.location.origin;
    $("#images").val($("#images_raw").val());
  },
};
</script>
